import React from "react";
import { observer } from "mobx-react-lite";
import { Hooks } from "@xt/xtbase";
import step2Img from "@/assets/img/cfd-guide/guide1.png";
import lineImg from "@/assets/img/cfd-guide/line.png";
import addIcon from "@/assets/img/add.png";
import { useCfdGuideStageRect } from "./useCfdGuideStageRect";
import { useCfdGuideAnchoredTipLayout } from "./useCfdGuideAnchoredTipLayout";
import styles from "./ProGuideStep2.module.scss";

const { useTranslation } = Hooks;

export type ProGuideStep2Props = {
  onSkip: () => void;
  onNext: () => void;
};

const DESIGN_WIDTH = 375;

function getScale(): number {
  if (typeof window === "undefined") return 1;
  const w = window.innerWidth || DESIGN_WIDTH;
  return w / DESIGN_WIDTH;
}

const ProGuideStep2: React.FC<ProGuideStep2Props> = ({ onSkip, onNext }) => {
  const t = useTranslation();

  const scale = getScale();
  const anchor = useCfdGuideStageRect('[data-guide-target="cfdStandardGuideDeposit"]');
  const tipLayout = useCfdGuideAnchoredTipLayout(anchor, scale);

  const imgSrc = (step2Img as any)?.src || (step2Img as any);
  const lineImgSrc = (lineImg as any)?.src || (lineImg as any);
  const addIconSrc = (addIcon as any)?.src || (addIcon as any);

  return (
    <div style={{ ["--sg-scale" as any]: scale }}>
      {anchor && tipLayout ? (
        <>
          <div
            className={styles.highlightRect}
            style={{
              position: "fixed",
              left: anchor.left,
              top: anchor.top,
              width: anchor.width,
              height: anchor.height,
              zIndex: 10001,
            }}
          >
            <div className={styles.depositBtn}>
              <img src={addIconSrc} alt="" />
            </div>
          </div>

          <div
            className={styles.tip}
            style={{
              position: "fixed",
              left: tipLayout.tipLeft,
              top: anchor.top + anchor.height + tipLayout.gapBelow,
              width: tipLayout.tipWidth,
              zIndex: 10001,
            }}
          >
            <div className={styles.tipBg}>
              <div className={styles.tipText}>
                <div className={styles.tipTitle}>{t("cfd.guide.pro.step2.title")}</div>
                <div className={styles.tipDesc}>{t("cfd.guide.pro.step2.desc")}</div>
              </div>
              <img className={styles.tipImg} src={imgSrc} alt="" />
            </div>
            <div className={styles.star1} />
            <div className={styles.star2} />
            <img
              className={styles.lineImg}
              src={lineImgSrc}
              alt=""
              style={{
                left: tipLayout.lineCenterInTip,
                transform: "translateX(-50%)",
              }}
            />
          </div>
        </>
      ) : null}

      <div className={styles.btnGroup}>
        <button type="button" className={`${styles.btn} ${styles.btnPrimary}`} onClick={onNext}>
          {`${t("cfd.guide.next")} 2/9`}
        </button>
        <button type="button" className={`${styles.btn} ${styles.btnGhost}`} onClick={onSkip}>
          {t("cfd.guide.skip")}
        </button>
      </div>
    </div>
  );
};

export default observer(ProGuideStep2);
